import sanitizeHtml from 'sanitize-html';

const DEFAULT_ALLOWED_TAGS = [
  'b',
  'i',
  'p',
  'ul',
  'li',
  'ol',
  'hr',
  'br',
  'em',
  'strong',
  'a',
  'blockquote',
  'span',
];
const DEFAULT_ALLOWED_ATTRIBUTES = {
  a: ['href'],
  span: ['class', 'data-id', 'data-label'],
};
export const sanitizeHTML = ({
  value,
  allowedTags = DEFAULT_ALLOWED_TAGS,
  allowedAttributes = DEFAULT_ALLOWED_ATTRIBUTES,
}) => {
  return sanitizeHtml(value, {
    allowedTags: allowedTags,
    allowedAttributes: allowedAttributes,
  });
};
